import { Box, Typography } from '@mui/material';

interface CarouselPillProps {
  label: string;
  onClick: () => void;
}

export const CarouselPill = ({ label, onClick }: CarouselPillProps) => {
  return (
    <Box sx={styles.wrapper} onClick={onClick}>
      <Box sx={styles.pill}>
        <Typography variant="body2">{label}</Typography>
      </Box>
    </Box>
  );
};

const styles = {
  wrapper: {
    display: 'inline-block',
    pr: 1,
    width: 'fit-content',
  },
  pill: {
    border: 1.5,
    borderColor: 'grey75',
    boxSizing: 'border-box',
    borderRadius: 6,
    py: 1,
    px: 2,
    cursor: 'pointer',
    userSelect: 'none',
    WebkitTouchCallout: 'none',
    WebkituserSelect: 'none',
    color: 'grey175',
    '&:hover': {
      bgcolor: 'grey50',
    },
  },
};
